import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    simulationClockDayOffset: 0
}

const simulationClockSlice = createSlice({
    name: 'simulationClock',
    initialState,
    reducers: {
        resetSimulationClockState: () => initialState,
    },
});

export const { resetSimulationClockState } = simulationClockSlice.actions;

// Write the offset into redux-persist storage, then reload. The page should not
// render the new offset first: redux-persist saves asynchronously, so a reload
// that follows a normal dispatch comes back with the previous value.
export function commitSimulationClockDayOffset(dayOffset) {
    const PERSIST_KEY = 'persist:root'
    const rawPersistedRoot = localStorage.getItem(PERSIST_KEY)
    const persistedRoot = rawPersistedRoot ? JSON.parse(rawPersistedRoot) : {}
    const currentClock = persistedRoot.simulationClock ? JSON.parse(persistedRoot.simulationClock) : {}

    persistedRoot.simulationClock = JSON.stringify({
        ...currentClock,
        simulationClockDayOffset: dayOffset
    })

    localStorage.setItem(PERSIST_KEY, JSON.stringify(persistedRoot))
    window.location.reload()
}

export default simulationClockSlice.reducer;